export default __webpack_public_path__ + "images/83a9cfaf2aa33919307b77ea8530deaf-valentines_date.webp";